import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useModal from "../../store/modal";
import useRoutes from "../../store/routes";
import { toast } from "../../utils/toast";
import { deleteRoutesApi } from "../../api/routes";
import Assign from './modalModules/assign'
import PreferedHour from './modalModules/preferedHour'
import CreateCustomTable from './modalModules/createCustomTable'
import { FullInput } from '../inputs/index'

import { modalInfo } from "./constants";
import { deleteIntegrationApi } from "../../api/user";
import { addShopify, addFalabella, addSendu, addWoocommerce, changeAliasApi, addRipley, deleteIntegration } from "api/integrations";
import "../../scss/_integration-modals.scss";

export const ActionButton = ({ text, primary, secondary, onClick }) => {
  return (
    <div
      style={{
        color: secondary,
        backgroundColor: primary,
        borderColor: secondary,
      }}
      onKeyUp={onClick}
      onClick={onClick}
      className="w-full my-2 py-1 rounded-sm text-center font-semibold border-2 cursor-pointer hover:scale-[1.02] hover:shadow-md transition"
    >
      {text}
    </div>
  );
};

const DeleteRoute = () => {
  const { t } = useTranslation();
  const fetchRoutes = useRoutes((state) => state.fetchRoutes);
  const deselectAllRoutes = useRoutes((state) => state.deselectAllRoutes);
  const selectedRoutes = useRoutes((state) => state.selectedRoutes);
  const closeModal = useModal((state) => state.closeModal);

  const deleteSelectedRoutes = () => {
    return new Promise((resolve, reject) => {
      if (selectedRoutes.length === 0) {
        toast.error(t("No hay rutas seleccionadas"));
        reject(false);
      }
      if (selectedRoutes.length === 1) {
        toast
          .promise(deleteRoutesApi(selectedRoutes[0]), {
            pending: t("Eliminando ruta"),
            success: t("Ruta eliminada correctamente."),
            error: t("Error al eliminar ruta"),
          })
          .then(() => {
            fetchRoutes().then(() => {
              deselectAllRoutes();
              resolve(true);
            });
          });
      } else {
        toast
          .promise(deleteRoutesApi(selectedRoutes), {
            pending: t("Eliminando ruta"),
            success: t("Ruta eliminada correctamente."),
            error: t("Error al eliminar ruta"),
          })
          .then(() => {
            fetchRoutes().then(() => {
              deselectAllRoutes();
              resolve(true);
            });
          });
      }
    });
  };

  return (
    <>
      <div className="text-sm">
        {t(
          "Esta acción eliminará la/s ruta/s. Todos los clientes que estaban asignados quedarán libres para asignar a una nueva ruta.",
        )}
      </div>
      <ActionButton
        text={t("Eliminar Ruta")}
        primary="#FFEFED"
        secondary="#E11900"
        onClick={() => {
          deleteSelectedRoutes().then(() => {
            closeModal();
          });
        }}
      />
    </>
  );
};

const SelectDates = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);

  const handleClick = async () => {
    closeModal();
  };

  return (
    <div className="p-2">
      <div className="flex flex-col gap-2 ">
        <FullInput type="date" />
        <FullInput type="date" />
      </div>
      <ActionButton
        text={t("Cambiar Fechas")}
        primary="#FFEFED"
        secondary="#E11900"
        onClick={handleClick}
      />
    </div>
  );
};

const DeleteIntegration = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const { clientId, alias, integrationName, integrationId, handleModalClose } = useModal((state) => state.props);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      // Use the new ID-based endpoint when integrationId is available (preferred)
      const deletePromise = integrationId
        ? deleteIntegration(integrationId)
        : deleteIntegrationApi({ clientId, alias, integrationName });

      await toast.promise(deletePromise, {
        pending: t('Eliminando...'),
        success: t('¡Integración eliminada correctamente!'),
        error: t('Ha ocurrido un error al eliminar la integración.'),
      });

      if (typeof handleModalClose === 'function') {
        handleModalClose();
      }
      closeModal();
    } catch (error) {
      console.error(error);

      if (error?.response?.status === 404) {
        toast.error(error?.response?.data?.error || t('Integración no encontrada'));
      } else {
        toast.error(t('Ha ocurrido un error al eliminar la integración. Por favor, intenta nuevamente.'));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="text-sm">
        {t("Esta acción eliminará la integración con el alias")}{" "}
        <b>{alias}</b>{" "}
        {t("de {{name}}.", { name: integrationName })}{" "}
        {t("Esta acción no es reversible.")}
      </div>
      <ActionButton
        text={isLoading ? t("Eliminando...") : t("Eliminar Integración")}
        primary="#FFEFED"
        secondary="#E11900"
        onClick={isLoading ? undefined : handleClick}
      />
    </>
  );
};

const AddFalabella = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { handleModalClose } = useModal((state) => state.props);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const falabella = await addFalabella({ sender_id: input, integrationName: 'Falabella' });

      if (falabella?.error?.statusCode === 400) {
        toast.error(t('Código Falabella ya existe.'));
      } else {
        toast.success(t('Código registrado correctamente'));
        closeModal();
        if (typeof handleModalClose === 'function') handleModalClose();
      }
    } catch (error) {
      console.error(error?.response || error);
      toast.error(t('Ha ocurrido un error al agregar el código de Falabella.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="integration-modal-simple">
      <label className="integration-modal-label">{t("Código Falabella")}</label>
      <input
        type="text"
        onChange={(e) => setInput(e.target.value)}
        className="integration-modal-input"
        placeholder={t("Ingresa el código")}
      />
      <button
        className="integration-modal-primary-btn"
        onClick={handleClick}
        disabled={isLoading}
      >
        {isLoading ? t("Guardando...") : t("Guardar")}
      </button>
    </div>
  );
};

const AddRipley = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { handleModalClose } = useModal((state) => state.props);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const ripley = await addRipley({ sender_id: input, integrationName: 'Ripley' });

      if (ripley?.error?.statusCode === 400) {
        toast.error(t('Código Ripley ya existe.'));
      } else {
        toast.success(t('Código registrado correctamente'));
        closeModal();
        if (typeof handleModalClose === 'function') handleModalClose();
      }
    } catch (error) {
      console.error(error?.response || error);
      toast.error(t('Ha ocurrido un error al agregar el código de Ripley.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="integration-modal-simple">
      <label className="integration-modal-label">{t("Código Ripley")}</label>
      <input
        type="text"
        onChange={(e) => setInput(e.target.value)}
        className="integration-modal-input"
        placeholder={t("Ingresa el código")}
      />
      <button
        className="integration-modal-primary-btn"
        onClick={handleClick}
        disabled={isLoading}
      >
        {isLoading ? t("Guardando...") : t("Guardar")}
      </button>
    </div>
  );
};

const AddSendu = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { handleModalClose } = useModal((state) => state.props);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const sendu = await addSendu({ sender_id: input, integrationName: 'Sendu' });

      if (sendu?.error?.statusCode === 400) {
        toast.error(t('Código Sendu ya existe.'));
      } else {
        toast.success(t('Código registrado correctamente'));
        closeModal();
        if (typeof handleModalClose === 'function') handleModalClose();
      }
    } catch (error) {
      console.error(error?.response || error);
      toast.error(t('Ha ocurrido un error al agregar el código de Sendu.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="integration-modal-simple">
      <label className="integration-modal-label">{t("Código Sendu")}</label>
      <input
        type="text"
        onChange={(e) => setInput(e.target.value)}
        className="integration-modal-input"
        placeholder={t("Ingresa el código")}
      />
      <button
        className="integration-modal-primary-btn"
        onClick={handleClick}
        disabled={isLoading}
      >
        {isLoading ? t("Guardando...") : t("Guardar")}
      </button>
    </div>
  );
};

const WOO_UPDATE_URL = "https://beartrackapp.github.io/woocommerce-connector/update.json";

/**
 * WooCommerce: paso 1 (guardar URL) → paso 2 (descargar plugin)
 * El botón de descarga usa SIEMPRE `download_url` de update.json.
 */
const AddWoocommerce = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const [domain, setDomain] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { handleModalClose } = useModal((state) => state.props);
  const [errorMessage, setErrorMessage] = useState('');
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [step, setStep] = useState(1);

  useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      try {
        const res = await fetch(WOO_UPDATE_URL, { signal: ctrl.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (!json?.download_url) throw new Error("Campo download_url ausente");
        setDownloadUrl(json.download_url);
      } catch (e) {
        console.error("Woo update.json error:", e);
      }
    })();
    return () => ctrl.abort();
  }, []);

  const normalizeDomain = (value) =>
    value.trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '');

  const handleChange = (e) => {
    setErrorMessage('');
    setDomain(e.target.value);
  };

  const handleClick = async () => {
    const cleanDomain = normalizeDomain(domain);
    if (!cleanDomain) {
      setErrorMessage(t('Ingresa el dominio de tu tienda.'));
      return;
    }

    const normalized = `https://${cleanDomain}`;
    setIsLoading(true);
    setErrorMessage('');

    try {
      const woocommerce = await addWoocommerce({
        url: normalized,
        integrationName: 'WooCommerce',
      });

      if (woocommerce?.error?.statusCode === 400) {
        setErrorMessage(t('Este sitio ya se encuentra registrado.'));
      } else {
        toast.success(t('Tienda registrada correctamente'));
        setStep(2);
      }
    } catch (error) {
      console.error(error?.response || error);
      setErrorMessage(t('No se pudo guardar. Intenta nuevamente.'));
    } finally {
      setIsLoading(false);
    }
  };

  const terminar = () => {
    closeModal();
    if (typeof handleModalClose === 'function') handleModalClose();
  };

  return (
    <div className="integration-modal-url-form">
      {step === 1 && (
        <>
          <p className="integration-modal-url-description">
            {t(
              "Ingresa la URL de tu tienda WooCommerce. Luego instalarás el plugin que conecta los pedidos con BearTrack.",
            )}
          </p>

          <div className="integration-modal-field">
            <label className="integration-modal-label" htmlFor="woo-domain">
              {t("URL de tu tienda")}
            </label>
            <div className={`integration-modal-input-group ${errorMessage ? 'integration-modal-input-group--error' : ''}`}>
              <span className="integration-modal-input-prefix">https://</span>
              <input
                id="woo-domain"
                type="text"
                className="integration-modal-url-input"
                placeholder="tutienda.com"
                value={domain}
                onChange={handleChange}
                onKeyDown={(e) => e.key === 'Enter' && !isLoading && handleClick()}
                autoComplete="off"
                spellCheck={false}
              />
            </div>
            {errorMessage
              ? <p className="integration-modal-error integration-modal-error--with-icon">⚠ {errorMessage}</p>
              : (
                <div className="integration-modal-format-hint">
                  <span className="integration-modal-format-hint__label">{t("Formato esperado:")}</span>
                  <code className="integration-modal-format-hint__code">tutienda.com</code>
                </div>
              )
            }
          </div>

          <button
            className="integration-modal-primary-btn"
            onClick={handleClick}
            disabled={isLoading || !domain.trim()}
          >
            {isLoading ? (
              <span className="integration-modal-btn-loading">
                <span className="integration-modal-spinner" />
                {t("Guardando...")}
              </span>
            ) : `${t("Guardar y continuar")} →`}
          </button>
        </>
      )}

      {step === 2 && (
        <div className="integration-modal-content">
          {/* Paso completado */}
          <div className="integration-modal-step-success">
            <span className="integration-modal-step-success__icon">✓</span>
            <div>
              <p className="integration-modal-step-success__title">{t("Tienda registrada")}</p>
              <p className="integration-modal-step-success__sub">https://{normalizeDomain(domain) || 'tutienda.com'}</p>
            </div>
          </div>

          <p className="integration-modal-text">
            {t("Ahora descarga e instala el plugin en tu sitio WooCommerce para empezar a sincronizar pedidos.")}
          </p>

          <a
            href={downloadUrl || '#'}
            target="_blank"
            rel="noreferrer noopener"
            className={`integration-modal-download-link ${!downloadUrl ? 'integration-modal-download-link--disabled' : ''}`}
            aria-disabled={!downloadUrl}
          >
            {downloadUrl ? `⬇ ${t("Descargar plugin WooCommerce")}` : t("Cargando enlace...")}
          </a>

          <div className="integration-modal-info-card">
            <p className="integration-modal-info-card__title">{t("Tras instalar el plugin:")}</p>
            <ol className="integration-modal-info-card__list">
              <li>{t("Ve a")}{" "}<strong>{t("WooCommerce → Ajustes → BearTrack Connector")}</strong></li>
              <li>{t("Los pedidos nuevos se sincronizarán automáticamente")}</li>
            </ol>
          </div>

          <div className="integration-modal-actions">
            <button className="integration-modal-secondary-btn" onClick={() => setStep(1)}>
              ← {t("Volver")}
            </button>
            <button className="integration-modal-success-btn" onClick={terminar}>
              {t("Listo")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const AddShopify = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const [domain, setDomain] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { handleModalClose, client } = useModal((state) => state.props);
  const [errorMessage, setErrorMessage] = useState('');

  const normalizeDomain = (value) => {
    // Strip protocols and trailing slashes the user might paste
    return value
      .trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/+$/, '');
  };

  const handleChange = (e) => {
    setErrorMessage('');
    setDomain(e.target.value);
  };

  const handleClick = async () => {
    const cleanDomain = normalizeDomain(domain);

    if (!cleanDomain) {
      setErrorMessage(t('Ingresa el dominio de tu tienda.'));
      return;
    }
    if (!cleanDomain.endsWith('.myshopify.com')) {
      setErrorMessage(t('El dominio debe terminar en .myshopify.com — por ejemplo: mi-tienda.myshopify.com'));
      return;
    }

    const shopDomain = `https://${cleanDomain}`;
    const clientId = client?.user?.id;

    setIsLoading(true);
    try {
      const shopify = await addShopify({ shopDomain, clientId });

      if (shopify?.error?.statusCode === 400) {
        setErrorMessage(t('Esta tienda ya se encuentra registrada.'));
      } else {
        toast.success(t('Tienda Shopify vinculada correctamente'));
        closeModal();
        if (typeof handleModalClose === 'function') handleModalClose();
      }
    } catch (error) {
      console.error(error?.response || error);
      setErrorMessage(t('No se pudo registrar la tienda. Intenta nuevamente.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="integration-modal-url-form">
      {/* Descripción */}
      <p className="integration-modal-url-description">
        {t(
          "Ingresa el dominio de tu tienda Shopify para conectarla con BearTrack. Los pedidos se crearán automáticamente.",
        )}
      </p>

      {/* Input group */}
      <div className="integration-modal-field">
        <label className="integration-modal-label" htmlFor="shopify-domain">
          {t("Dominio de tu tienda")}
        </label>
        <div className={`integration-modal-input-group ${errorMessage ? 'integration-modal-input-group--error' : ''}`}>
          <span className="integration-modal-input-prefix">https://</span>
          <input
            id="shopify-domain"
            type="text"
            className="integration-modal-url-input"
            placeholder="mi-tienda.myshopify.com"
            value={domain}
            onChange={handleChange}
            onKeyDown={(e) => e.key === 'Enter' && !isLoading && handleClick()}
            autoComplete="off"
            spellCheck={false}
          />
        </div>
        {errorMessage
          ? <p className="integration-modal-error integration-modal-error--with-icon">⚠ {errorMessage}</p>
          : (
            <div className="integration-modal-format-hint">
              <span className="integration-modal-format-hint__label">{t("Formato esperado:")}</span>
              <code className="integration-modal-format-hint__code">mi-tienda.myshopify.com</code>
            </div>
          )
        }
      </div>

      {/* Cómo encontrarlo */}
      <div className="integration-modal-info-card">
        <p className="integration-modal-info-card__title">{t("¿Dónde encuentro mi dominio?")}</p>
        <ol className="integration-modal-info-card__list">
          <li>{t("Entra a tu panel de administración de Shopify")}</li>
          <li>{t("Ve a")}{" "}<strong>{t("Configuración → Dominio")}</strong></li>
          <li>{t("Copia el dominio que termina en")}{" "}<code>.myshopify.com</code></li>
        </ol>
      </div>

      <button
        className="integration-modal-primary-btn"
        onClick={handleClick}
        disabled={isLoading || !domain.trim()}
      >
        {isLoading ? (
          <span className="integration-modal-btn-loading">
            <span className="integration-modal-spinner" />
            {t("Guardando...")}
          </span>
        ) : t("Vincular tienda")}
      </button>
    </div>
  );
};

const ChangeAlias = () => {
  const { t } = useTranslation();
  const closeModal = useModal((state) => state.closeModal);
  const { companyId, alias, integrationName, changeAlias } = useModal((state) => state.props);
  const [newAlias, setNewAlias] = useState(alias);
  const [saving, setSaving] = useState(false);

  const trimmed = (newAlias || "").trim();
  const invalid = trimmed === "" || trimmed === alias;

  const handleClick = async () => {
    if (invalid) {
      toast.error(t("El alias no puede estar vacío ni ser igual al anterior"));
      return;
    }
    try {
      setSaving(true);
      await toast.promise(changeAliasApi({ companyId, alias, integrationName, newAlias: trimmed }), {
        pending: t('Modificando...'),
        success: t('¡Alias modificado correctamente!'),
        error: t('Ha ocurrido un error al modificar el Alias.'),
      });

      if (typeof changeAlias === 'function') changeAlias(alias, trimmed);
      closeModal();
    } catch (error) {
      console.error(error);

      if (error?.response?.status === 404) {
        toast.error(error?.response?.data?.error || t('Usuario no encontrado'));
      } else {
        toast.error(t('Ha ocurrido un error al modificar el alias. Por favor, intenta nuevamente.'));
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="integration-modal-content">
      <p className="integration-modal-help-text">
        {t("Edita el nombre con el que identificas esta cuenta de {{name}}.", { name: integrationName })}
      </p>

      <div className="integration-modal-field">
        <label className="integration-modal-label" htmlFor="change-alias-input">
          {t("Alias de la cuenta")}
        </label>
        <input
          id="change-alias-input"
          type="text"
          className="integration-modal-input"
          value={newAlias}
          autoFocus
          placeholder={t("Ej: Tienda principal")}
          onChange={(e) => setNewAlias(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !invalid && !saving) handleClick();
          }}
        />
      </div>

      <div className="integration-modal-actions">
        <button
          type="button"
          className="integration-modal-secondary-btn"
          onClick={closeModal}
          disabled={saving}
        >
          {t("Cancelar")}
        </button>
        <button
          type="button"
          className="integration-modal-primary-btn"
          style={{ flex: 1 }}
          onClick={handleClick}
          disabled={invalid || saving}
        >
          {saving ? (
            <span className="integration-modal-btn-loading">
              <span className="integration-modal-spinner" />
              {t("Guardando...")}
            </span>
          ) : (
            t("Guardar cambios")
          )}
        </button>
      </div>
    </div>
  );
};

export default function ModalProvider() {
  const { t } = useTranslation();
  const name = useModal((state) => state.modalName);
  const closeModal = useModal((state) => state.closeModal);
  const props = useModal((state) => state.props);

  return (
    <>
      {name !== "" && (
        <section>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className={`relative w-auto my-6 mx-auto ${name === 'orderRules' ? 'max-w-3xl' : name === 'AddShopify' || name === 'AddWoocommerce' ? 'max-w-xl' : 'max-w-lg'}`}>
              {/*content*/}
              <div className="integration-modal-wrapper border-0 px-4 py-3 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                {/*header*/}
                <div
                  className="integration-modal-header-close cursor-pointer hover:scale-105 transition w-5 h-5 text-center flex items-center justify-center absolute -top-2 -right-1 rounded-xl outline-none focus:outline-none"
                  onClick={closeModal}
                  onKeyUp={closeModal}
                >
                  <span className="font-bold -translate-y-[1px]">x</span>
                </div>
                <h3 className="integration-modal-title-header text-xl py-1 font-semibold">
                  {t(modalInfo[name].title)}
                </h3>
                <div className="integration-modal-divider w-full h-[1px] my-1" />

                <>
                  {(() => {
                    switch (name) {
                      case "deleteRoute":
                        return <DeleteRoute />;
                      case "deleteIntegration":
                        return <DeleteIntegration />;
                      // "orderRules" vive ahora en la vista de integraciones
                      // (OrderRulesDrawer, montado localmente — no via store).
                      case "changeAlias":
                        return <ChangeAlias />;
                      case "AddFalabella":
                        return <AddFalabella />;
                      case "AddRipley":
                        return <AddRipley />;
                      case "AddSendu":
                        return <AddSendu />;
                      case "AddWoocommerce":
                        return <AddWoocommerce />;
                      case "AddShopify":
                        return <AddShopify />;
                      case "preferedHour":
                        return <PreferedHour clientId={props.id} />;
                      case "assignTo":
                        return <Assign />;
                      case "createCustomTable":
                        return <CreateCustomTable />;
                      case "selectDates":
                        return <SelectDates />;
                      default:
                        return null;
                    }
                  })()}
                </>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </section>
      )}
    </>
  );
}
